import { isEqual } from 'lodash';

export const invalidationMiddleware =
  (store: any) => (next: any) => (action: any) => {
    const prevState = store.getState();
    const result = next(action);
    const nextState = store.getState();

    const policyInfo = [
      'portfolioRiskScore',
      'assetAllocations',
      'sectorBreakdown',
      'regionlBreakdown',
      'countryBreakdown'
    ];

    const dependencies = [
      {
        module: 'case',
        source: 'existingPolicies',
        targets: [
          'existingPoliciesRiskScore',
          'existingPoliciesCharges',
          'existingAssetAllocations',
          'existingSectorBreakdown',
          'existingRegionlBreakdown',
          'existingCountryBreakdown',
          ...policyInfo
        ]
      },
      {
        module: 'case',
        source: 'policies',
        targets: [
          'recommendedPoliciesCharges',
          'recommendedPoliciesRiskScore',
          ...policyInfo
        ]
      },
      {
        module: 'case',
        source: 'allAggregateCostAndCharges*',
        targets: ['recommendedPoliciesCharges']
      }
    ];

    dependencies.forEach((item: any) => {
      let keys = [item.source];
      if (item.source.includes('*')) {
        keys = Object.keys(prevState[item.module]).filter(key =>
          key.startsWith(item.source.split('*')[0])
        );
      }

      if (
        keys.some(
          key =>
            !isEqual(prevState[item.module][key], nextState[item.module][key])
        )
      ) {
        store.dispatch({
          type: 'case/INVALIDATE_STORE_SUBSET',
          payload: item.targets
        });
      }
    });

    return result;
  };
